// extracted by mini-css-extract-plugin
export default {"ellipsis":"ZccInstallationRowLight__ellipsis___D5YbP","viewList":"ZccInstallationRowLight__viewList___Hqgu6"};